
/**
 * 新闻列表数据 API
 */
module.exports = {
  //  newsURI: 'http://localhost:5050' // 本地开发启用此项
  newsURI: '' // 发布时启用此项
}
